import { Navigate } from 'react-router-dom'
import { ClientShell } from '@/components/ClientShell/ClientShell'
import { RequireStaffAuth } from '@/components/RequireStaffAuth'
import { TarefasPage } from '@/pages/TarefasPage'
import { isAdmin } from '@/utils/adminAuth'
import { isProfissional } from '@/utils/profissionalAuth'

/** Rota partilhada: admin vê a app cliente; profissional vai ao painel próprio. */
export function StaffTarefasRoute() {
  return (
    <RequireStaffAuth>
      {isProfissional() && !isAdmin() ? (
        <Navigate to="/profissional/tarefas" replace />
      ) : (
        <ClientShell>
          <TarefasPage />
        </ClientShell>
      )}
    </RequireStaffAuth>
  )
}
